import { Box, styled } from "@mui/material";

export const PbiReportContainer = styled(Box)({
  height: "100%",

  "& .report-style-class": {
    height: "100%",
  },

  "& iframe": {
    border: "none",
  },
});
